// src/components/common/MaintenanceBanner/MaintenanceBanner.styles.ts

import { tokens, mixins } from 'src/design-system';

const bannerBase = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `6px ${tokens.spacing.md}px`,
  width: '100%',
  zIndex: tokens.zIndex.navbar + 1,
  position: 'relative' as const,
};

export const styles = (theme) => ({
  banner: {
    ...bannerBase,
    background: '#FFFBE6',
    borderBottom: '1px solid #FFE58F',
  },
  bannerIncident: {
    ...bannerBase,
    background: '#FFF1F0',
    borderBottom: '1px solid #FFCCC7',
  },
  bannerResolved: {
    ...bannerBase,
    background: '#F6FFED',
    borderBottom: '1px solid #B7EB8F',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  warningIcon: {
    fontSize: tokens.fontSize.body,
    flexShrink: 0,
    marginRight: tokens.spacing.xs,
  },
  incidentIcon: {
    fontSize: tokens.fontSize.small,
    flexShrink: 0,
    marginRight: tokens.spacing.xs,
  },
  text: {
    fontSize: tokens.fontSize.small,
    color: '#874D00',
    lineHeight: 1.5,
  },
  textIncident: {
    fontSize: tokens.fontSize.small,
    color: '#820014',
    lineHeight: 1.5,
  },
  textResolved: {
    fontSize: tokens.fontSize.small,
    color: '#135200',
    lineHeight: 1.5,
  },
  bold: {
    fontWeight: tokens.fontWeight.semibold,
  },
  dismissButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: `0 ${tokens.spacing.xs}px`,
    fontSize: tokens.fontSize.body,
    flexShrink: 0,
    opacity: 0.5,
    position: 'absolute' as const,
    right: tokens.spacing.md,
    color: 'inherit',
    '&:hover': {
      opacity: 1,
    },
  },
});
